import { useQuery } from '@tanstack/react-query';

import { getLineItemData } from '../api/ventura/contract';
import { useConfig } from './useConfig';

// Opts into the per-domain flip via apiHostFor('contractReportsBigQuery') — ACH serves
// the per-IO summary table (io_data) as of ACH-24na, answering it from one
// shared BigQuery read alongside its two siblings. The {"data":[rows]} envelope is
// identical to Rails', so there is no response adaptation.
//
// Reaching ACH still requires the gate: outside DEV that means an allowlisted tester
// who enabled the ACH backend for their own session. See apiHostFor.ts.
function useContractLineItemData(contractId: number) {
  const { apiHostFor } = useConfig();
  const bigQueryHost = apiHostFor('contractReportsBigQuery');

  const query = useQuery({
    queryKey: ['contractIoData', contractId],
    queryFn: () => getLineItemData(bigQueryHost, contractId),
  });

  return query;
}

export default useContractLineItemData;
